import { render, staticRenderFns } from "./updateAvatar.vue?vue&type=template&id=188e81f6"
import script from "./updateAvatar.vue?vue&type=script&lang=ts"
export * from "./updateAvatar.vue?vue&type=script&lang=ts"
import style0 from "./updateAvatar.vue?vue&type=style&index=0&id=188e81f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports